import { Observable, Subscription } from 'rxjs';
import { Component, Renderer2, OnInit, OnDestroy, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import {
  NgcCookieConsentService,
  NgcInitializationErrorEvent,
  NgcInitializingEvent,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent,
} from 'ngx-cookieconsent';

import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { AuthServicesService } from './auth/services/auth-services.service';
import { ChatService } from './chat.service';
import { CreateOrderService } from './click-it/create-order/cement/Services/create-order.service';
import { UtilsService } from './shared/services/utils.service';
import { SentryErrorHandler } from './sentry/sentry-error-handler';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SurveyMonkeyService } from './click-it/survey-monkey/survey-monkey.service';
import { NpsSurveyService } from './click-it/nps-survey/nps-survey.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:resize)': 'onWindowResize($event)',
  },
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  surveyUrl: SafeResourceUrl | null = null;
  onlineEvent!: Observable<Event>;
  offlineEvent!: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage: any;
  connectionStatus: any;
  localLanguage: any;
  title = 'af-notification';
  message: any = null;
  fireBaseToken: any;
  versionUpadted: boolean = false;
  isMobile = false;
  width: number = window.innerWidth;
  height: number = window.innerHeight;
  mobileWidth: number = 760;
  direction: any;
  businessData: any;
  userDetails: any;
  dashboardDetails: any;
  currentUrl: any;
  showWindowResize: boolean = true;
  showNavigationPopup: boolean = false;
  showSpinner: boolean = false;
  storeDataSubscribe: any;
  storeDataSubscribe2: any;
  chatEnable: boolean = false;
  showError: boolean = false;
  isClickitUser: boolean = false;
  enableSentry = false;
  apilink: any;
  region: any;
  surveyExecuted: boolean = false;
  constructor(
    public translate: TranslateService,
    private readonly store: Store<any>,
    private readonly ccService: NgcCookieConsentService,
    private readonly renderer: Renderer2,
    private readonly router: Router,
    private readonly swUpdate: SwUpdate,
    private readonly auth: AuthServicesService,
    private readonly chatService: ChatService,
    private readonly createService: CreateOrderService,
    private readonly utilService: UtilsService,
    private readonly sentryErrorHandler: SentryErrorHandler,
    private readonly authService: AuthServicesService,
    private readonly surveyMonkeyService: SurveyMonkeyService,
    public readonly npsSurveyService: NpsSurveyService,
    private readonly sanitizer: DomSanitizer,
  ) {
    if (!location.href.includes('localhost')) {
      this.getUpdate();
    }
    this.enableSentry = environment.enableSentry;
    this.storeDataSubscribe = this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localLanguage = data?.authReducer?.localLanguage;
        this.businessData = data.authReducer?.businessDetails;
        this.userDetails = data?.authReducer?.userDetails;
        this.dashboardDetails = data?.authReducer?.dashboardDetails;
        this.chatEnable = data?.authReducer?.userDetails?.settings_data?.IS_CHAT_ENABLED ?? false;
        this.apilink = data.authReducer?.allApiLinks?.business?.href
        this.handleDirection();
        this.showWindowResize = data.cartReducer?.cartData?.isMobile;
        this.handleTranslate();
        // if (this.auth.isLoggedIn() && this.businessData?.settings_data?.SURVEY_MONKEY_ID?.nps) {
        //   this.sessionStorage();
        // }
        this.sentryErrorHandler.updateSentryUser(this.userDetails?.id, this.userDetails?.email, this.userDetails?.first_name);
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.showSpinner = true;
      }
      if (event instanceof NavigationEnd) {
        console.log(this.surveyExecuted, 'appComp');
        if (this.auth.isLoggedIn() && this.businessData?.settings_data?.SURVEY_MONKEY_ID?.nps) {
          const currentUrl = window.location.href;

          if (!currentUrl.includes('create-orders') && !currentUrl.includes('login')) {
            this.npsSurveyService?.checkAndShow('completion_screen');
          }
          const savedSurveyUrl =
            localStorage.getItem('nps_survey_url');

          // if (savedSurveyUrl) {
          //   this.surveyUrl =
          //     this.sanitizer.bypassSecurityTrustResourceUrl(
          //       savedSurveyUrl
          //     );
          // }
          this.actionCountStorage(event.urlAfterRedirects);
          const userId = this.userDetails?.id;
          const surveyDateStorage = JSON.parse(
            localStorage.getItem('surveyCreationDates') ?? '{}'
          );
          const storedDate = surveyDateStorage[userId];
          console.log("TIme", storedDate);
          // if (storedDate) {
          //   this.checkSurveyEligibility(storedDate);

          // } else {
          //   this.authService?.getSurveyDetails().subscribe({
          //     next: (res) => {
          //       console.log(res);
          //       // const apiDate = res?.date_created ?? new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString();
          //       const apiDate = res?.date_created ?? new Date(Date.now()).toISOString();
          //       if (apiDate) {

          //         surveyDateStorage[userId] = apiDate;

          //         localStorage.setItem(
          //           'surveyCreationDates',
          //           JSON.stringify(surveyDateStorage)
          //         );
          //         localStorage.setItem(
          //           'surveyResponseType',
          //           res.response_type
          //         );
          //         this.checkSurveyEligibility(apiDate);
          //       }
          //     },
          //     error: (err) => {
          //       console.log(err);
          //     }
          //   });
          // }
        }


        // console.log(currentLoginCount, surveyLoginCount, 'TESTURL');
        // if (currentLoginCount >= surveyLoginCount) {
        //   if (!this.surveyExecuted) {
        //     console.log("appComp");
        //     this.executeSurveyCode();
        //   }
        // }

        this.showSpinner = false;
      }
    });
  }

  private lastTrackedUrl: string = '';
  actionCountStorage(url: string) {
    if (this.lastTrackedUrl === url) {
      return;
    }

    this.lastTrackedUrl = url;
    const userId = this.userDetails?.id;
    const loginCountKey = `surveyLoginCount_${userId}`;
    let currentLoginCount = Number(
      localStorage.getItem(loginCountKey) ?? 0
    );

    currentLoginCount++;
    localStorage.setItem(
      loginCountKey,
      currentLoginCount.toString()
    );

  }



  sessionStorage() {
    const userId = this.userDetails?.id;

    const surveyLoginCount =
      this.dashboardDetails?.settings_data?.SURVEY_MONKEY_RULES?.nps?.login_session_count ?? 3;

    const loginCountKey = `surveyLoginCount_${userId}`;
    const tabSessionKey = `surveyTabSession_${userId}`;
    const processingKey = `surveyProcessing_${userId}`;

    // Already counted for this tab
    const alreadyCounted = sessionStorage.getItem(tabSessionKey);

    // Prevent duplicate execution
    const isProcessing = sessionStorage.getItem(processingKey);

    if (!alreadyCounted && !isProcessing) {

      // Set processing lock immediately
      sessionStorage.setItem(processingKey, 'true');

      let currentLoginCount = Number(
        localStorage.getItem(loginCountKey) ?? 0
      );

      currentLoginCount++;

      localStorage.setItem(
        loginCountKey,
        currentLoginCount.toString()
      );

      // Mark this tab as counted
      sessionStorage.setItem(tabSessionKey, 'true');

      // Remove processing lock
      sessionStorage.removeItem(processingKey);

      console.log('Session Count:', currentLoginCount);
    }
  }
  checkSurveyEligibility(createdDate: string | null) {
    // let isEligibleForSurvey = true;
    // createdDate = createdDate ?? new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString();
    createdDate = createdDate ?? new Date(Date.now()).toISOString();
    console.log("TIme", createdDate);
    const surveyTime = new Date(createdDate).getTime();
    const surveyResponseType =
      localStorage.getItem('surveyResponseType');

    let blockForMinutes =
      Number(
        this.businessData?.settings_data?.SURVEY_MONKEY_RULES?.nps?.block_for_mins
      ) || 2;

    if (surveyResponseType === 'skipped_for_7_days') {
      // blockForMinutes = 10080;
      blockForMinutes = 1;

    } else if (surveyResponseType === 'skipped_for_30_days') {
      // blockForMinutes = 43200;
      blockForMinutes = 2;

    } else if (surveyResponseType === 'skipped_for_90_days') {
      // blockForMinutes = 129600;
      blockForMinutes = 3;
    }

    const blockTime = blockForMinutes * 60 * 1000;

    const nextEligibleTime = surveyTime + blockTime;

    const currentTime = Date.now();

    const isEligibleForSurvey =
      currentTime >= nextEligibleTime;
    console.log(isEligibleForSurvey, 'TIme');

    console.log("TIme test", 'Survey Time:', new Date(surveyTime));
    console.log("TIme test", 'Next Eligible:', new Date(nextEligibleTime));
    console.log("TIme test", 'Current Time:', new Date(currentTime));
    console.log("TIme test", 'Eligible:', isEligibleForSurvey);
    const surveyLoginCount =
      this.businessData?.settings_data?.SURVEY_MONKEY_RULES?.nps?.login_session_count ?? 3;
    const loginCountKey = `surveyLoginCount_${this.userDetails?.id}`;
    let currentLoginCount = Number(
      localStorage.getItem(loginCountKey) ?? 0
    );

    console.log(currentLoginCount >= surveyLoginCount, "Check Time");
    // const activeUserInMin = 1;
    // const delayTime = activeUserInMin * 60 * 1000;
    // let surveyStartTime = localStorage.getItem('surveyStartTime');

    // if (!surveyStartTime) {
    //   surveyStartTime = Date.now().toString();
    //   localStorage.setItem('surveyStartTime', surveyStartTime);
    // }

    // const elapsedTime =
    //   Date.now() - Number(surveyStartTime);

    // const remainingTime =
    //   delayTime - elapsedTime;
    console.log("TIme test remaing", currentLoginCount >= surveyLoginCount, isEligibleForSurvey);
    if (
      currentLoginCount >= surveyLoginCount &&
      isEligibleForSurvey
    ) {
      this.checkForDateOnSurvey();
      // if (remainingTime <= 0) {

      //   console.log('Show Survey');
      //   this.checkForDateOnSurvey();
      //   // this.executeSurveyCode();
      // }
    }
  }

  checkForDateOnSurvey() {
    const surveyStoredDate = JSON.parse(
      localStorage.getItem('surveyCreationDates') ?? '{}'
    );
    const userId = this.userDetails?.id;
    const storedDate = surveyStoredDate[userId];
    this.authService.getSurveyDetails().subscribe({
      next: (res) => {
        const apiCreatedDate = res?.date_created;
        console.log(surveyStoredDate, apiCreatedDate, 'checkTime');

        const isSameDate =
          storedDate &&
          new Date(storedDate).getTime() ===
          new Date(apiCreatedDate).getTime();
        console.log(isSameDate, 'TIme');

        if (isSameDate || !res?.date_created) {
          this.executeSurveyCode();
        } else if (res?.date_created) {
          console.log(isSameDate, 'TIme');
          const userId = this.userDetails?.id;
          const surveyDateStorage = JSON.parse(
            localStorage.getItem('surveyCreationDates') ?? '{}'
          );

          surveyDateStorage[userId] = res?.created_at;

          localStorage.setItem(
            'surveyCreationDates',
            JSON.stringify(surveyDateStorage)
          );
          localStorage.setItem(
            'surveyResponseType',
            res.response_type
          );
        }
      }, error: (err) => {
        console.log(err);

      }
    })
  }
  executeSurveyCode() {
    const needToShowSurvey = JSON.parse(
      localStorage.getItem('needToShowSurvey') ?? 'false'
    );

    console.log("load started", needToShowSurvey);

    if (!needToShowSurvey) {
      return;
    }

    if (this.apilink?.includes("-ic-")) {
      this.region = 'mea';
      console.log(this.region);
    } else if (this.apilink?.includes("-eu-")) {
      this.region = 'eu';
      console.log(this.region);
    }
    console.log(needToShowSurvey, 'appComp');
    console.log("load started", needToShowSurvey);
    // setTimeout(() => {
    //   this.loadSurvey();
    // }, 5000);
    const activeUserInMin = parseFloat(this.businessData?.settings_data?.SURVEY_MONKEY_RULES?.nps?.active_use_in_min);
    // const activeUserInMin = 1;
    const delayTime = activeUserInMin * 60 * 1000;
    let surveyStartTime = localStorage.getItem('surveyStartTime');

    if (!surveyStartTime) {
      surveyStartTime = Date.now().toString();
      localStorage.setItem('surveyStartTime', surveyStartTime);
    }

    const elapsedTime =
      Date.now() - Number(surveyStartTime);

    const remainingTime =
      delayTime - elapsedTime;
    console.log("TIme test remaing", remainingTime);

    if (remainingTime <= 0) {
      this.loadSurvey();
    }
    //  else {

    //   setTimeout(() => {
    //     this.loadSurvey();
    //   }, remainingTime);

    // }
  }

  loadSurvey() {
    console.log("load started");

    let userData = {
      id: this.userDetails?.id,
      name: this.userDetails?.first_name + this.userDetails?.last_name,
      email: this.userDetails?.email,
      phone: this.userDetails?.phone,
      region: this.region + this.userDetails?.id,
      country: this.userDetails?.country?.name,
      survey_id: this.businessData?.settings_data?.SURVEY_MONKEY_ID?.nps,
      lang:  this.userDetails?.country?.locale?.split('-')[0]
    };

    console.log('load started', userData);


    this.surveyUrl =
      this.surveyMonkeyService.loadSurvey(userData);

    console.log(this.surveyUrl, 'load started');

    // Optional cleanup
    localStorage.removeItem('surveyStartTime');
    localStorage.removeItem('surveyCreationDates');
  }
  closeSurveyComponent() {
    this.surveyUrl = null;
  }
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const keysToBlock = ['ArrowDown', 'ArrowUp'];
    if (keysToBlock.includes(event.key)) {
      event.preventDefault();
    }
  }
  handleDirection() {
    if (((this.auth.isLoggedIn()) && (this.chatEnable)) && (!this.chatService.isConnected())) {
      this.chatService.connect();
    }

    if (this.localLanguage?.direction) {
      this.direction = this.localLanguage?.direction;
      localStorage.setItem('languageDirection', this.direction);
    } else if (localStorage.getItem('languageDirection') === 'undefined') {
      this.direction = 'ltr';
      // navigator.language.substring(0,2) == 'ar'
    } else if (navigator.language.startsWith('ar') || localStorage.getItem('languageDirection') == 'rtl') {
      this.direction = 'rtl';
      // navigator.language.substring(0,2) !== 'ar'
    } else if (!navigator.language.startsWith('ar')) {
      this.direction = 'ltr';
      localStorage.setItem('languageDirection', this.direction)
    }
  }
  handleTranslate() {
    if (this.localLanguage?.locale) {
      this.translate.use(this.localLanguage?.locale?.replace('-', ''));
    } else if (this.direction == 'rtl') {
      this.translate.use('arEG');
    } else {
      this.translate.use('enGB');
    }
    this.direction = this.direction ?? 'ltr';
    this.renderer.removeClass(document.body, 'rtl');
    this.renderer.removeClass(document.body, 'ltr');
    this.renderer.addClass(document.body, this.direction);
    console.log(!location.href.includes('localhost'));

    if (
      !location.href.includes('localhost') &&
      !location.href.includes('aws-clickit-web-staging.clickitapp.io') &&
      !location.href.includes('aws-clickit-web-qa.clickitapp.io') &&
      !location.href.includes('web.clickitapp.io') &&
      (this.userDetails?.country?.locale == 'en-GB' ||
        this.userDetails?.country?.locale == 'fr-FR')
    ) {
      this.showNavigationPopup = false;
    }
  }
  ngOnInit(): void {




    // setInterval(() => {
    //    this.getIpLocationService();
    // }, 100);
    this.utilService.isClickitUser$.subscribe(status => {
      this.isClickitUser = status;
    });

    this.createService.showError.subscribe((res: any) => {
      if (res) {
        this.showError = true;
      }
    });
    if (this.showWindowResize) {
      if (this.width < this.mobileWidth) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
    localStorage.setItem('localLanguageCode', navigator.language)
    // Get the online/offline status from browser window
    this.subscriptions.push(
      this.ccService.popupOpen$.subscribe(() => { }),
      this.ccService.popupClose$.subscribe(() => { }),
      this.ccService.initializing$.subscribe(
        (event: NgcInitializingEvent) => { }
      ),
      this.ccService.initialized$.subscribe(() => { }),
      this.ccService.initializationError$.subscribe(
        (event: NgcInitializationErrorEvent) => { }
      ),
      this.ccService.statusChange$.subscribe((event: NgcStatusChangeEvent) => {
        localStorage.setItem('status', event.status);
        if (event.status === 'allow') {
          document.cookie = "cookieconsent_status=allow; path=/; domain=" + window.location.hostname + "; secure; samesite=Strict";
        }
      }),
      this.ccService.revokeChoice$.subscribe(() => { }),
      this.ccService.noCookieLaw$.subscribe((event: NgcNoCookieLawEvent) => { })
    );

    this.storeDataSubscribe2 = this.store
      .select((state) => state)
      .subscribe((data) => {
        this.localLanguage = data?.authReducer?.localLanguage;
        this.translate.addLangs(['en', 'fr']);
        this.translate
          .get([
            'cookie-header',
            'cookie-message',
            'cookie-dismiss',
            'cookie-allow',
            'cookie-deny',
            'cookie-link',
            'cookie-policy',
          ])
          .subscribe((data) => {
            const config = this.ccService.getConfig();
            config.content = config?.content ?? {};
            // Override default messages with the translated ones
            if (config?.content) {
              config.content.header = data['cookie-header'];
              config.content.message = data['cookie-message'];
              config.content.dismiss = data['cookie-dismiss'];
              config.content.allow = data['cookie-allow'];
              config.content.deny = data['cookie-deny'];
              config.content.link = data['cookie-link'];
              config.content.policy = data['cookie-policy'];
            }
            this.ccService.destroy(); // remove previous cookie bar (with default messages)
            this.ccService.init(config); // update config with translated messages
          });
      });

    this.subscriptions.push(this.storeDataSubscribe, this.storeDataSubscribe2);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js?v=1.0.0')
        .then((registration) => {
          console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((err) => {
          console.log('Service Worker registration failed:', err);
        });
    }
    localStorage.removeItem("signupFormData");
    localStorage.removeItem("otpResp");
  }

  getIpLocationService() {
    this.authService.getIpLocation().subscribe({
      next: (res) => {
        if (res.status) {
          localStorage.setItem('IpLocation', JSON.stringify(res.data))
        }
        console.log(res, 'IpLocation');

      }, error: (err) => {
        console.log(err);

      }
    })
  }


  //service-worker
  getUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          this.versionUpadted = true;
        }
      });
    }
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.height = event.target.innerHeight;
    // if (this.showWindowResize) {
    //   if (this.width < this.mobileWidth) {
    //     this.isMobile = true;
    //   } else {
    //     this.isMobile = false;
    //   }
    // }
    if (this.showWindowResize) {
      const isFoldableMobile = /Android|iPhone|iPod/i.test(navigator.userAgent);
      // console.log(isFoldableMobile,'isFoldableMobile,',navigator.userAgent)
      if (this.width < this.mobileWidth || isFoldableMobile) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }
  }

  NavigateToAWS(val: any) {
    const NavigateUrl = 'https://web.clickitapp.io/';
    if (val == 'anchor') {
      window.open(NavigateUrl, '_blank', 'noopener');
    } else if (val == 'button') {
      window.location.href = NavigateUrl;
    }
  }

  movetoClickit(event: any) {
    event.stopPropagation();
    const loginData = localStorage.getItem('loginData');
    const parsedData = loginData ? JSON.parse(loginData) : null;
    window.open(`${parsedData?.clickit_link}`, '_blank');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
